import React from 'react';

const PrivacyPolicyLink = () => {
  const pdfPath = `${process.env.PUBLIC_URL}/documents/${encodeURIComponent('Statify Privacy Policy.pdf')}`;

  return (
    <div style={{
      padding: '20px',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6'
    }}>
      <h1 style={{ 
        color: '#2c3e50',
        borderBottom: '2px solid #3498db',
        paddingBottom: '10px'
      }}>
        Privacy & Security
      </h1>

      <p style={{ fontSize: '16px', marginBottom: '25px' }}>
        We value your privacy and are committed to protecting your personal information. 
        Our Privacy Policy explains how we collect, use, and safeguard your data when 
        you use our services.
      </p>

      <div style={{ 
        backgroundColor: '#f8f9fa',
        padding: '15px',
        borderRadius: '8px',
        margin: '20px 0',
        border: '1px solid #e9ecef'
      }}>
        <p style={{ margin: '0 0 10px 0', fontWeight: '500' }}>
          To review our complete privacy practices and policies, please read our:
        </p>
        <a 
          href={pdfPath}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            e.preventDefault();
            window.open(pdfPath, '_blank', 'noopener,noreferrer');
          }}
          style={{
            color: '#3498db',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '18px',
            display: 'inline-block',
            transition: 'all 0.3s ease',
            padding: '8px 15px',
            borderRadius: '4px'
          }}
          onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
          onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
        >
          📄 Full Privacy Policy Document
        </a>
      </div>

     

      
    </div>
  );
};

export default PrivacyPolicyLink;